import { render, staticRenderFns } from "./PsGroupsList.vue?vue&type=template&id=7dd996da&scoped=true&"
import script from "./PsGroupsList.vue?vue&type=script&lang=js&"
export * from "./PsGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsList.vue?vue&type=style&index=0&id=7dd996da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd996da",
  null
  
)

export default component.exports